// extracted by mini-css-extract-plugin
export default {"zoomModal":"O1-z","image":"P1-z","button":"Q1-z","isOverlayShown":"R1-z"};